const AMAP_KEY = 'fb8a9eec55bfb18a58ef67e2a144a967'
const AMAP_SECURITY_CODE = '59750a7050f355f9fcf84ba86df62b61'
const AMAP_SCRIPT_ID = 'amap-js-sdk'
let amapPromise = null

export default function loadAmap () {
  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }
  if (amapPromise) {
    return amapPromise
  }

  window._AMapSecurityConfig = {
    securityJsCode: AMAP_SECURITY_CODE
  }

  amapPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(AMAP_SCRIPT_ID)
    if (existing) {
      existing.addEventListener('load', () => resolve(window.AMap))
      existing.addEventListener('error', reject)
      return
    }

    const script = document.createElement('script')
    script.id = AMAP_SCRIPT_ID
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${AMAP_KEY}&plugin=AMap.PlaceSearch,AMap.Geocoder,AMap.Scale`
    script.onload = () => resolve(window.AMap)
    script.onerror = (error) => {
      amapPromise = null
      reject(error)
    }
    document.head.appendChild(script)
  })

  return amapPromise
}



// WEBPACK FOOTER //
// ./src/utils/amap.js